import qs from "qs";
import { ApiClientBase } from "api/ApiClientBase";

class FederationSummaryApiClient extends ApiClientBase {
    buildFederationSummary(federationId, format) {
        return this.post(
            `api/v1/federation/summary/${federationId}/build?${qs.stringify({ format })}`,
        ).then((x) => x.data);
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new FederationSummaryApiClient();
